export default __webpack_public_path__ + "static/media/email-small.bbc535fd.svg";